import { Pipe, PipeTransform } from '@angular/core';

import { Container } from '../../container';

@Pipe({ name: 'collabContainerPipe' })
export class CollabContainerPipe implements PipeTransform {
  transform(containers: Container[], collab: boolean): Container[] {
    return containers.filter(c => c.is_collab || c.is_collab === collab);
  }
}
